import OfferCancelledReason from "@/models/JobWorkerOffers/OfferCancelledReason";

export default (value: OfferCancelledReason) => {
    switch (value) {
        case OfferCancelledReason.CreatedByMistake:
            return "Created by mistake";
        case OfferCancelledReason.ContactBudgetIssue:
            return "Budget issue";
        case OfferCancelledReason.ContactChangedMind:
            return "Contact changed mind";
        case OfferCancelledReason.ContactFoundAlternativeWorker:
            return "Found alternative worker";
        case OfferCancelledReason.ContactPositionNoLongerRequired:
            return "Position no longer required";
        default:
            return "Unknown";
    }
} 